export interface DeviceWizardRegistration {
  deviceType:
    | "camera"
    | "thermostat"
    | "access"
    | "panel"
    | "hvac"
    | "water-leak";
  macPrefixes: string[];
  wizardRoute: string;
  displayName: string;
}

class DeviceRegistryService {
  private registrations: Map<string, DeviceWizardRegistration> = new Map();

  register(registration: DeviceWizardRegistration) {
    this.registrations.set(registration.deviceType, registration);
    console.log(
      `📝 Registered device wizard: ${registration.deviceType} -> ${registration.wizardRoute}`
    );
  }

  getWizardRoute(deviceType: string): string | undefined {
    const registration = this.registrations.get(deviceType);
    return registration?.wizardRoute;
  }

  detectDeviceType(macId: string): string | undefined {
    const normalizedMac = macId.toUpperCase().replace(/[:-]/g, "");

    for (const [deviceType, registration] of this.registrations.entries()) {
      for (const prefix of registration.macPrefixes) {
        const normalizedPrefix = prefix.toUpperCase().replace(/[:-]/g, "");
        if (normalizedMac.startsWith(normalizedPrefix)) {
          return deviceType;
        }
      }
    }

    return undefined;
  }

  getDisplayName(deviceType: string): string {
    const registration = this.registrations.get(deviceType);
    return registration?.displayName || deviceType;
  }

  getAllRegistrations(): DeviceWizardRegistration[] {
    return Array.from(this.registrations.values());
  }
}

export const deviceRegistry = new DeviceRegistryService();
